import React, { useEffect, useState, useCallback } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  PriceTypeSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import NoAccess from "../NoAccess";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function Customers() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.name1.toLowerCase().includes(lowerValue) ||
        item.name2.toLowerCase().includes(lowerValue) ||
        item.customerId.toLowerCase().includes(lowerValue) ||
        item.id.toString().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion




//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState({
    description: "",
    isActive: true,
    CustomerId: "",
    name1: "",
    name2: "",
    street: "",
    cityId: "",
    districtId: "",
    countryId: "",
    regionId: "",
    zip: "",
    mobile: "",
    telephone: "",
    tin: "",
    fax: "",
    email: "",
    searchTerm: "",
    isEWT: "",
    priceType: "",
    terms: "",
    salesman: "",
    salesmans: [],
    certificateOfRegistration: "",
  });

  const resetVariables = () => {
    setSelectedData(null);

    setFormData({
      description: "",
      isActive: true,
      customerId: "",
      name1: "",
      name2: "",
      street: "",
      cityId: "",
      districtId: "",
      countryId: "",
      regionId: "",
      zip: "",
      mobile: "",
      telephone: "",
      tin: "",
      fax: "",
      email: "",
      searchTerm: "",
      isEWT: "",
      priceType: "",
      terms: "",
      salesman: "",
      salesmans: [],
      certificateOfRegistration: "",
    })
  }
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = {
      customerId: formData?.customerId,
      name1: formData?.name1,
      name2: formData?.name2,
      street: formData?.street,
      cityId: formData?.cityId,
      districtId: formData?.districtId,
      countryId: formData?.countryId,
      regionId: formData?.regionId,
      zip: formData?.zip,
      mobile: formData?.mobile,
      telephone: formData?.telephone,
      tin: formData?.tin,
      fax: formData?.fax,
      email: formData?.email,
      searchTerm: formData?.searchTerm,
      isEWT: formData?.isEWT,
      priceType: formData?.priceType,
      terms: formData?.terms,
      salesman: formData?.salesman,
      salesmans: formData?.salesmans,
      certificateOfRegistration: formData?.certificateOfRegistration?.base64,
      createdDate: new Date(),
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Customer`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Customer/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);


  const editHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setFormData({
      description: _data.description ?? "",
      isActive: _data.isActive ?? true,
      customerId: _data.customerId ?? "",
      name1: _data.name1 ?? "",
      name2: _data.name2 ?? "",
      street: _data.street ?? "",
      cityId: _data.cityId ?? "",
      districtId: _data.districtId ?? "",
      countryId: _data.countryId ?? "",
      regionId: _data.regionId ?? "",
      zip: _data.zip ?? "",
      mobile: _data.mobile ?? "",
      telephone: _data.telephone ?? "",
      tin: _data.tin ?? "",
      fax: _data.fax ?? "",
      email: _data.email ?? "",
      searchTerm: _data.searchTerm ?? "",
      isEWT: _data.isEWT ?? false,
      priceType: _data.priceType ?? "",
      terms: _data.terms ?? "",
      salesman: _data.salesman ?? "",
      salesmans: _data.salesmans ?? [],
      certificateOfRegistration: _data.certificateOfRegistration
        ? {
            base64: _data.certificateOfRegistration,
            contentType: DetectMimeTypeFromBase64(
              _data.certificateOfRegistration
            ),
            fileName: `Certificate_of_Registration.${DetectMimeTypeFromBase64(
              _data.certificateOfRegistration
            ).split("/")[1]}`
          }
        : null
    });

    setLoading(false);
    openUpdateForm();
  };

  const handleUpdateData = async () => {
    const data = {
      customerId: formData?.customerId,
      name1: formData?.name1,
      name2: formData?.name2,
      street: formData?.street,
      cityId: formData?.cityId,
      districtId: formData?.districtId,
      countryId: formData?.countryId,
      regionId: formData?.regionId,
      zip: formData?.zip,
      mobile: formData?.mobile,
      telephone: formData?.telephone,
      tin: formData?.tin,
      fax: formData?.fax,
      email: formData?.email,
      searchTerm: formData?.searchTerm,
      isEWT: formData?.isEWT,
      priceType: formData?.priceType,
      terms: formData?.terms,
      salesman: formData?.salesman,
      salesmans: formData?.salesmans,
      certificateOfRegistration: formData?.certificateOfRegistration?.base64,
      updatedDate: new Date(),
    };

    try {
      setLoading(true);

      await axios.put(`${apiUrl}/api/Customer/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion









// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setFormData({
      description: _data.description ?? "",
      isActive: _data.isActive ?? true,
      customerId: _data.customerId ?? "",
      name1: _data.name1 ?? "",
      name2: _data.name2 ?? "",
      street: _data.street ?? "",
      cityId: _data.cityId ?? "",
      districtId: _data.districtId ?? "",
      countryId: _data.countryId ?? "",
      regionId: _data.regionId ?? "",
      zip: _data.zip ?? "",
      mobile: _data.mobile ?? "",
      telephone: _data.telephone ?? "",
      tin: _data.tin ?? "",
      fax: _data.fax ?? "",
      email: _data.email ?? "",
      searchTerm: _data.searchTerm ?? "",
      isEWT: _data.isEWT ?? false,
      priceType: _data.priceType ?? "",
      terms: _data.terms ?? "",
      salesman: _data.salesman ?? "",
      salesmans: _data.salesmans ?? [],
      certificateOfRegistration: _data.certificateOfRegistration
        ? {
            base64: _data.certificateOfRegistration,
            contentType: DetectMimeTypeFromBase64(
              _data.certificateOfRegistration
            ),
            fileName: `Certificate_of_Registration.${DetectMimeTypeFromBase64(
              _data.certificateOfRegistration
            ).split("/")[1]}`
          }
        : null
    });

    setLoading(false);
    openViewForm();
  };
//#endregion




//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'CUSTOMER ID', 
    'NAME', 
    'EMAIL', 
    'CONTACTS', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'customerId', 
    'name', 
    'email', 
    'contacts', 
    'actions'
  ]

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/Customer` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion



//#region Export
  const handleExport = async () => {
    setLoading(true);

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Customers List");

      // 1. Define Columns
      worksheet.columns = [
        { header: "Customer Id", key: "customerId", width: 20 },
        { header: "Name", key: "name", width: 35 },
        { header: "Name 1", key: "name1", width: 25 },
        { header: "Name 2", key: "name2", width: 25 },
        { header: "Street", key: "street", width: 35 },
        { header: "City Id", key: "cityId", width: 15 },
        { header: "District Id", key: "districtId", width: 15 },
        { header: "Country Id", key: "countryId", width: 15 },
        { header: "Region Id", key: "regionId", width: 15 },
        { header: "Zip", key: "zip", width: 12 },
        { header: "Mobile", key: "mobile", width: 20 },
        { header: "Telephone", key: "telephone", width: 20 },
        { header: "TIN", key: "tin", width: 20 },
        { header: "Fax", key: "fax", width: 20 },
        { header: "Email", key: "email", width: 35 },
        { header: "Is EWT", key: "isEWT", width: 12 },
        { header: "Price Type", key: "priceType", width: 20 },
        { header: "Terms", key: "terms", width: 20 },
      ];

      // 2. Add Data
      data.forEach((item) => {
        worksheet.addRow({
          customerId: item.customerId || "",
          name: item.name || "",
          name1: item.name1 || "",
          name2: item.name2 || "",
          street: item.street || "",
          cityId: item.cityId ?? "",
          districtId: item.districtId ?? "",
          countryId: item.countryId ?? "",
          regionId: item.regionId ?? "",
          zip: item.zip || "",
          mobile: item.mobile || "",
          telephone: item.telephone || "",
          tin: item.tin || "",
          fax: item.fax || "",
          email: item.email || "",
          isEWT: item.isEWT ? "Yes" : "No",
          priceType: item.priceType || "",
          terms: item.terms || "",
        });
      });

      // 3. Style Header
      const headerRow = worksheet.getRow(1);

      headerRow.height = 30;

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FF3B82F6",
          },
        };

        cell.font = {
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          size: 11,
          name: "Arial",
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // 4. Style Data Cells
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          row.height = 22;

          row.eachCell((cell) => {
            cell.font = {
              name: "Arial",
              size: 10,
            };

            cell.alignment = {
              vertical: "middle",
              horizontal: "left",
              indent: 1,
            };

            cell.border = {
              bottom: {
                style: "thin",
                color: { argb: "FFE5E7EB" },
              },
              left: {
                style: "thin",
                color: { argb: "FFE5E7EB" },
              },
              right: {
                style: "thin",
                color: { argb: "FFE5E7EB" },
              },
            };
          });
        }
      });

      // 5. Freeze Header
      worksheet.views = [
        {
          state: "frozen",
          ySplit: 1,
        },
      ];

      // 6. Enable Auto Filter
      worksheet.autoFilter = {
        from: "A1",
        to: `R${Math.max(data.length + 1, 2)}`,
      };

      // 7. Finalize and Download
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(
        blob,
        `Customers_Template_${new Date()
          .toISOString()
          .split("T")[0]}.xlsx`
      );
    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setLoading(false);
    }
  };
//#endregion

//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasCustomers) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <ReduceCapacityIcon fontSize="large" className="text-theme-color" />
              {`Customer (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">Source of revenue for your business.</p>
          </div>
          <div className="flex gap-3">
            <button onClick={handleExport} className="flex items-center gap-1.5 px-4 py-2 text-gray-500 hover:text-theme-color hover:bg-gray-100 rounded-md text-sm font-medium transition-all border">
              <FileDownloadIcon sx={{ fontSize: 16 }} />
              Export
            </button>

            <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Customer
            </button>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by customer id or name or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"Customer"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Data"}

        data={data}
        formData={formData} setFormData={setFormData}
        isEditable={true}
      />


      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Data"}

        data={data}
        formData={formData} setFormData={setFormData}
        isEditable={true}
      />


      <AddUpdateModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleUpdateData}
        modalName={"View Data"}

        data={data}
        formData={formData} setFormData={setFormData}
        isEditable={false}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}







//#region AddUpdate Modal
const AddUpdateModal = ({
  visible,
  onClose,
  onSave,
  modalName,
  data,
  formData,
  setFormData,
  isEditable
}) => {
  const [failMessage, setFailMessage] = useState("");

  const [currentSalesman, setCurrentSalesman] = useState("");

  const addSalesman = () => {
    if (currentSalesman.trim() !== "") {
      setFormData({
        ...formData,
        // Change: Push an object with the key 'name'
        salesmans: [...formData.salesmans, { name: currentSalesman.trim() }]
      });
      setCurrentSalesman(""); 
    }
  };

  const removeSalesman = (indexToRemove) => {
    setFormData({
      ...formData,
      salesmans: formData.salesmans.filter((_, index) => index !== indexToRemove)
    });
  };

  if (!visible) return null;

  const handleSubmit = async () => {
    // Updated validation based on your parameters
    if (!formData.customerId || !formData.name1) {
      setFailMessage("Please fill up required field/s (Customer ID and Name 1).");
      return;
    }

    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  const updateField = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // Reusable input class
  const inputClass = "w-full border rounded-md p-2 border-gray-300 outline-none text-sm focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color";
  const labelClass = "block text-xs font-bold mb-1 text-gray-600 uppercase tracking-wide";

  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      updateField("certificateOfRegistration", fileData);
    }
  };

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.95, opacity: 0, y: 20 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col max-h-[90vh]"
            >
              {/* Header */}
              <div className="px-8 py-5 border-b bg-white rounded-t-2xl flex justify-between items-center">
                <h2 className="text-2xl font-bold text-gray-800">
                  {modalName}
                </h2>
                <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
              </div>

              {/* Body */}
              <div className="p-8 overflow-y-auto custom-scrollbar">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
                  
                  {/* Left Column: Customer & Address */}
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-sm font-bold text-theme-color mb-4 border-b pb-1 uppercase">Customer Identity</h3>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="col-span-1">
                          <label className={labelClass}>Customer ID <span className="text-red-500">*</span></label>
                          <input type="text" className={inputClass} value={formData.customerId} onChange={(e) => updateField("customerId", e.target.value)} readOnly={!isEditable}/>
                        </div>
                        <div className="col-span-1">
                          <label className={labelClass}>Search Term</label>
                          <input type="text" className={inputClass} value={formData.searchTerm} onChange={(e) => updateField("searchTerm", e.target.value)}  readOnly={!isEditable}/>
                        </div>
                        <div className="col-span-2">
                          <label className={labelClass}>Name 1 (Company/Primary) <span className="text-red-500">*</span></label>
                          <input type="text" className={inputClass} value={formData.name1} onChange={(e) => updateField("name1", e.target.value)}  readOnly={!isEditable}/>
                        </div>
                        <div className="col-span-2">
                          <label className={labelClass}>Name 2 (Secondary)</label>
                          <input type="text" className={inputClass} value={formData.name2} onChange={(e) => updateField("name2", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div className="space-y-2 col-span-2">
                          <label htmlFor="salesman" className={labelClass}>
                            Salesmen
                          </label>
                          
                          {/* Input Group */}
                          {isEditable && 
                            <div className="flex gap-2">
                              <input
                                id="salesman-input"
                                type="text"
                                placeholder="e.g., Juan dela Cruz"
                                className={`${inputClass} flex-1`}
                                value={currentSalesman}
                                onChange={(e) => setCurrentSalesman(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    addSalesman();
                                  }
                                }}
                              />
                              <button
                                type="button"
                                onClick={addSalesman}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                              >
                                Add
                              </button>
                            </div>
                          }

                          {/* List of Added Salesmen */}
                          <div className="mt-3 space-y-2">
                            {formData.salesmans.map((salesmanObj, index) => (
                              <div 
                                key={index} 
                                className="flex items-center justify-between p-2 bg-gray-50 border rounded-md"
                              >
                                <span className="text-sm text-gray-700">{salesmanObj.name}</span>
                                
                                {isEditable && 
                                  <button
                                    type="button"
                                    onClick={() => removeSalesman(index)}
                                    className="text-red-500 hover:text-red-700"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                  </button>
                                }
                              </div>
                            ))}

                            {/* Added Logic Here */}
                            {formData.salesmans?.length === 0 && (
                              <div className="text-center py-4 border border-dashed rounded-md bg-gray-50/50">
                                <p className="text-sm text-gray-500">No Salesman Added</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-sm font-bold text-theme-color mb-4 border-b pb-1 uppercase">Physical Address</h3>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="col-span-2">
                          <label className={labelClass}>Street</label>
                          <input type="text" className={inputClass} value={formData.street} onChange={(e) => updateField("street", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>City</label>
                          <input type="text" className={inputClass} value={formData.cityId} onChange={(e) => updateField("cityId", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>District</label>
                          <input type="text" className={inputClass} value={formData.districtId} onChange={(e) => updateField("districtId", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>Region</label>
                          <input type="text" className={inputClass} value={formData.regionId} onChange={(e) => updateField("regionId", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>ZIP Code</label>
                          <input type="text" className={inputClass} value={formData.zip} onChange={(e) => updateField("zip", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div className="col-span-2">
                          <label className={labelClass}>Country</label>
                          <input type="text" className={inputClass} value={formData.countryId} onChange={(e) => updateField("countryId", e.target.value)} readOnly={!isEditable} />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Contact & Others */}
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-sm font-bold text-theme-color mb-4 border-b pb-1 uppercase">Contact Information</h3>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className={labelClass}>Mobile</label>
                          <input type="text" className={inputClass} value={formData.mobile} onChange={(e) => updateField("mobile", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>Telephone</label>
                          <input type="text" className={inputClass} value={formData.telephone} onChange={(e) => updateField("telephone", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>Fax</label>
                          <input type="text" className={inputClass} value={formData.fax} onChange={(e) => updateField("fax", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>Email Address</label>
                          <input type="email" className={inputClass} value={formData.email} onChange={(e) => updateField("email", e.target.value)} readOnly={!isEditable} />
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-sm font-bold text-theme-color mb-4 border-b pb-1 uppercase">Tax & Status</h3>
                      <div className="space-y-4">
                        <div>
                          <label className={labelClass}>Tax Identification Number (TIN)</label>
                          <input type="text" placeholder="000-000-000-000" className={inputClass} value={formData.tin} onChange={(e) => updateField("tin", e.target.value)} readOnly={!isEditable} />
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-sm font-bold text-theme-color mb-4 border-b pb-1 uppercase">Details</h3>
                      <div className="space-y-4">
                        <div>
                          <label className={labelClass}>Expanded Withholding Tax ( EWT )</label>
                          <button
                            type="button"
                            disabled={!isEditable}
                            onClick={(e) => updateField("isEWT", !formData.isEWT)}
                            className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                              formData.isEWT ? "bg-theme-color" : "bg-gray-400"
                            }`}
                          >
                            <span
                              className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                formData.isEWT ? "translate-x-7" : "translate-x-1"
                              }`}
                            />
                          </button>
                        </div>
                        <div>
                          <label className={labelClass}>Price Type</label>
                          <PriceTypeSelect
                            data={formData.priceType}
                            setData={(value) => updateField("priceType", value)}
                            isEditable={isEditable}
                          />
                          {/* <input type="text" className={inputClass} value={formData.priceType} onChange={(e) => updateField("priceType", e.target.value)} readOnly={!isEditable}/> */}
                        </div>
                        <div>
                          <label className={labelClass}>Terms</label>
                          <input type="text" className={inputClass} placeholder="30 Days" value={formData.terms} onChange={(e) => updateField("terms", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div className="hidden">
                          <label className={labelClass}>Salesman</label>
                          <input type="text" className={inputClass} placeholder="Juan Dela Cruz" value={formData.salesman} onChange={(e) => updateField("salesman", e.target.value)} readOnly={!isEditable} />
                        </div>
                        <div>
                          <label className={labelClass}>Certificate of Registration</label>

                          <div className="flex flex-col gap-2 mt-1">
                            <div className="flex items-center gap-2">
                              {/* File Input – accept ANY file */}
                              {isEditable &&
                                <input
                                  type="file"
                                  onChange={handleFileChange}
                                  className={`${inputClass} block w-full text-sm text-gray-500
                                    file:mr-4 file:py-2 file:px-4
                                    file:rounded file:border-0
                                    file:text-xs file:font-bold
                                    file:bg-theme-color file:text-white
                                    hover:file:bg-opacity-90 cursor-pointer`}
                                /> 
                              }

                              {/* Download / Check */}
                              {formData.certificateOfRegistration && (
                                <button
                                  type="button"
                                  onClick={() => DownloadFile(formData.certificateOfRegistration)}
                                  className="flex items-center gap-1 px-3 py-2 text-xs font-bold uppercase transition-colors border rounded
                                            border-theme-color text-theme-color hover:bg-theme-color hover:text-white"
                                  title="Download file"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-4 h-4"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                    />
                                  </svg>
                                  Check
                                </button>
                              )}
                            </div>

                            {/* File info */}
                            {formData.certificateOfRegistration ? (
                              <div className="text-[10px] text-green-600 font-medium">
                                <p>
                                  {formData.certificateOfRegistration.fileName}
                                </p>
                                <p className="text-gray-500">
                                  {formData.certificateOfRegistration.contentType || "Unknown file type"}
                                </p>
                              </div>
                              )
                              :
                              (
                                <div className="text-[10px] text-red-600 font-medium">
                                  <p>No file uploaded</p>
                                </div>
                              )
                            }
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="flex justify-end space-x-3 p-8 border-t bg-white rounded-b-2xl">
                <button
                  onClick={closeModal}
                  className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition font-medium"
                >
                  Cancel
                </button>

                {isEditable &&
                  <button
                    onClick={handleSubmit}
                    className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95"
                  >
                    Save Customer
                  </button>
                }
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};


//#endregion